export type BuildingData = {
  enabled?: number;
  name: string;
  cost: number;
  time: number;
  hp: number;
  armor: string;
  sight: number;
  footprint: [number, number];
  requires: string[];
  power: number;
  produces: string[];
  limit?: number;
  income?: number;
  upgrades?: string[];
  unload?: boolean;
  transport?: { capacity: number; range: number };
  freeUnit?: string;
  weapon?: string;
};

export const buildings: Record<string, BuildingData> = {
  oilDerrick: {
    name: "Oil derrick",
    cost: 0,
    time: 1,
    hp: 1200,
    armor: "building",
    sight: 600,
    footprint: [2, 2],
    requires: [],
    power: 0,
    produces: [],
  },
  repairDepot: {
    name: "Repair depot",
    cost: 0,
    time: 1,
    hp: 1200,
    armor: "building",
    sight: 600,
    footprint: [2, 2],
    requires: [],
    power: 0,
    produces: [],
  },
  sensorRelay: {
    name: "Sensor relay",
    cost: 0,
    time: 1,
    hp: 1200,
    armor: "building",
    sight: 900,
    footprint: [2, 2],
    requires: [],
    power: 0,
    produces: [],
  },
  crate: {
    name: "Money crate",
    cost: 0,
    time: 1,
    hp: 200,
    armor: "building",
    sight: 0,
    footprint: [1, 1],
    requires: [],
    power: 0,
    produces: [],
  },

  helipad: {
    enabled: 1,
    name: "Airfield",
    cost: 800,
    time: 18,
    hp: 900,
    armor: "building",
    sight: 600,
    footprint: [7, 6],
    requires: ["radar"],
    power: -2,
    produces: ["petrel", "reconDrone", "strikeDrone"],
  },
  samSite: {
    enabled: 1,
    name: "SAM tower",
    cost: 400,
    time: 10,
    hp: 1100,
    armor: "building",
    sight: 600,
    footprint: [2, 2],
    requires: ["radar"],
    power: -2,
    produces: [],
    weapon: "sam",
  },
  silo: {
    enabled: 1,
    name: "Strike center",
    cost: 4000,
    time: 40,
    hp: 1200,
    armor: "building",
    sight: 600,
    footprint: [3, 3],
    requires: ["radar"],
    power: -8,
    produces: [],
    limit: 3,
  },
  wall: {
    enabled: 1,
    name: "Wall",
    cost: 100,
    time: 2,
    hp: 500,
    armor: "building",
    sight: 600,
    footprint: [1, 1],
    requires: ["quarters"],
    power: 0,
    produces: [],
  },
  tradePost: {
    enabled: 1,
    name: "Trade post",
    cost: 1500,
    time: 25,
    hp: 1000,
    armor: "building",
    sight: 600,
    footprint: [3, 3],
    requires: ["depot"],
    power: -2,
    produces: [],
    limit: 3,
    income: 8,
  },
  radar: {
    enabled: 1,
    name: "Radar station",
    cost: 1000,
    time: 20,
    hp: 1000,
    armor: "building",
    sight: 600,
    footprint: [3, 3],
    requires: ["factory"],
    power: -3,
    produces: [],
  },
  headquarters: {
    enabled: 1,
    name: "Command center",
    cost: 2000,
    time: 40,
    hp: 3200,
    sight: 720,
    armor: "building",
    footprint: [4, 4],
    requires: [],
    power: 0,
    produces: ["builder"],
  },
  generator: {
    enabled: 1,
    name: "Power plant",
    cost: 800,
    time: 20,
    hp: 1100,
    sight: 600,
    armor: "building",
    footprint: [3, 3],
    requires: ["headquarters"],
    power: 6,
    upgrades: ["turbine"],
    produces: [],
  },
  depot: {
    enabled: 1,
    name: "Supply center",
    cost: 1500,
    time: 25,
    hp: 1600,
    sight: 600,
    armor: "building",
    footprint: [4, 3],
    requires: ["generator"],
    power: -1,
    produces: ["hauler"],
    unload: true,
    freeUnit: "hauler",
  },
  quarters: {
    enabled: 1,
    name: "Barracks",
    cost: 500,
    time: 15,
    hp: 1100,
    sight: 600,
    armor: "building",
    footprint: [3, 3],
    requires: ["generator"],
    power: 0,
    produces: ["rifleman", "grenadier", "rocketeer", "engineer"],
  },
  factory: {
    enabled: 1,
    name: "Vehicle factory",
    cost: 2000,
    time: 30,
    hp: 2200,
    sight: 600,
    armor: "building",
    footprint: [4, 4],
    requires: ["depot"],
    power: -1,
    produces: ["buggy", "strider", "hoverBattery", "bombard"],
  },
  tower: {
    enabled: 1,
    name: "Ground tower",
    cost: 500,
    time: 12,
    hp: 1600,
    sight: 600,
    armor: "building",
    footprint: [2, 2],
    requires: ["quarters"],
    power: -2,
    produces: [],
    weapon: "towerGun",
  },
  bunker: {
    enabled: 1,
    name: "Infantry bunker",
    cost: 450,
    time: 12,
    hp: 1200,
    armor: "building",
    sight: 600,
    footprint: [2, 2],
    requires: ["quarters"],
    power: 0,
    produces: [],
    transport: { capacity: 3, range: 32 },
  },
};
